export const sortByOrder = (a, b) => (a.order || 0) - (b.order || 0);
